<div class="grid-status" [ngClass]="['--' + text, !isBullet ? 'no-bullet' : '']">
    <img *ngIf="isBullet" [src]="ICONS.BULLET" />
    <span>{{status?.statusValue}}</span>
</div>